import { Button } from "@material-ui/core";
import React from "react";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";
import { CreateNewLeaseDialog } from "./CreateNewLeaseDialog";
import { UpdateLeaseDialog } from "./UpdateLeaseDialog";

export function AddOwnerButton() {
    const {
        selectedOwnerId: ownerId,
        openNewLeaseDialog,
        openUpdateLeaseDialog,
        addingOwner,
        handleAddOwner,
    } = useAddOwnerFlow();

    const inProgress = addingOwner || openNewLeaseDialog || openUpdateLeaseDialog;

    return (<>
        <Button
            variant="contained"
            color="primary"
            onClick={handleAddOwner}
            disabled={!ownerId || inProgress}
        >
            {inProgress ? "Adding Owner..." : "Add Owner"}
        </Button>

        <CreateNewLeaseDialog />

        <UpdateLeaseDialog />
    </>);
}
